<template>
  <div class="sticky-email">
    <div
      v-if="userDepartment.department_id == 1"
      class="sticky-email__attachment"
    >
      <h2 class="sticky-email__title">Attachments</h2>
      <hr style="width: 260px" />
      <b-button-group class="sticky-email__button-group">
        <b-overlay
          v-for="(attachment, index) in attachments"
          :key="index"
          :show="busy"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
          @hidden="onHidden"
        >
          <a :href="attachment" target="_blanck">
            <b-button
              ref="button"
              :disabled="busy"
              variant="primary"
              size="sm"
              aria-label="Click here to download the file"
              class="sticky-email__button"
            >
              Attachment {{ index + 1 }}
              <span>
                <i class="pi pi-external-link" style="font-size: .7rem"></i>
              </span>
            </b-button>
          </a>
        </b-overlay>
      </b-button-group>
    </div>
    <hr />
    <div class="sticky-email--dragbar" @mousedown="resizeSticky($event)"></div>
    <div class="sticky-content" v-html="content"></div>
  </div>
</template>

<script>
export default {
  name: "StickyEmail",
  props: {
    content: String,
    attachments: Array
  },
  data() {
    return {
      busy: false,
      userDepartment: null
    };
  },
  methods: {
    renderContent: function() {
      this.$el.querySelector(".sticky-content").innerHTML = this.content;
    },
    onHidden() {
      // Return focus to the button once hidden
      this.$refs.button.focus();
    },
    resizeSticky: function(event) {
      event.preventDefault();
      this.$emit("resizeSticky");
    },
    dragbarResizingEvent: function() {
      let sticky = this.$el.querySelector(".sticky-content");
      sticky.addEventListener("scroll", event => {
        let currentHeight = event.target.scrollTop + sticky.offsetHeight;
        this.$el.querySelector(".sticky-email--dragbar").style.height =
          currentHeight + "px";
      });
    }
  },
  created() {
    let department = localStorage.getItem("current-department");
    this.userDepartment = JSON.parse(department);
  },
  mounted: function() {
    this.renderContent();
    this.dragbarResizingEvent();
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.sticky-email {
  width: 30%;
  background-color: #fff;
  position: fixed;
  height: 100%;
  top: 0;
  right: 0;
  font-size: 14px;
  text-align: justify;
  z-index: 1000;
  &--dragbar {
    background-color: #e9ecef;
    height: 100%;
    float: left;
    width: 5px;
    cursor: col-resize;
    &:hover {
      background-color: rgba(255, 174, 111, 0.2);
      width: 7px;
    }
  }
  &__attachment {
    background: #eceff1;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &__title {
    padding: 10px;
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 1.8rem;
    color: #757575;
  }
  &__button-group {
    padding: 10px;
  }
  &__button {
    margin-right: 10px;
    @include primary-button;
  }
}

.sticky-content {
  padding: 20px;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  word-wrap: break-word;
}

.sticky-content::-webkit-scrollbar-track {
  background-color: #e9ecef;
}

.sticky-content::-webkit-scrollbar {
  width: 7px;
  background-color: #f5f5f5;
}

.sticky-content::-webkit-scrollbar-thumb {
  border-radius: 20px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: rgba(0, 0, 0, 0.1);
}
</style>
